import { get } from "lodash";
import { createSelector } from "reselect";

import { ALL_RESOURCE_KEYS } from "../../../constants/entity.js";
import { OPERATIONS } from "../../../constants/operations.js";

import { operationAvailable } from "../../../utils/operations.js";

// -- QUERIES -- //

const projectsQuery = state => get(state, "projects.data", null);
const permissionsQuery = state => get(state, "account.permissions", {});

// -- SELECTORS -- //

const selectResourcesList = () => {
  return createSelector(
    [projectsQuery, permissionsQuery],
    (projects, permissions) => {
      // bail early if we don't have a project
      if (!projects) return null;

      let result = projects.map(project => {
        const resources = ALL_RESOURCE_KEYS.map(key => {
          if (!Array.isArray(project[key])) return [];

          // filter out any resource that doesn't have add_schedule available
          return project[key].filter(item => {
            const test = operationAvailable(
              OPERATIONS.ADD_SCHEDULE,
              item.operations,
              item.enabledOperations,
              permissions
            );

            return test || false;
          });
        });

        return {
          "@id": project["@id"],
          id: project.id,
          name: project.name,
          resources: [].concat(...resources)
        };
      });

      return result;
    }
  );
};

// this is a necessary evil due to the current api structure
// getting a full resource list would otherwise require multipe calls to multiple resource type endpoints

// need to check resource.@id and planner.resource.@id ?

const selectResourcesByIds = (ids = []) => {
  return createSelector([projectsQuery], projects => {
    if (!projects || !Array.isArray(ids)) return null;

    const resources = projects.reduce((acc, project) => {
      const projectResources = ALL_RESOURCE_KEYS.reduce((rAcc, key) => {
        if (Array.isArray(project[key])) rAcc.push(project[key]);
        return rAcc;
      }, []);
      return acc.concat(...projectResources);
    }, []);

    const result = resources.filter(function (item) {
      return this.indexOf(item["@id"]) > -1;
    }, ids);

    return result;
  });
};

// using the following export pattern so we can mock more easily using jest

const projectsSelector = {
  selectResourcesList,
  selectResourcesByIds
};

export default projectsSelector;
